// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7851":"fd375093","9093":"fd375093"}[chunkId] + ".chunk.css";
};